var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScreenrecorder2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 740,
    height: 561.759,
    viewBox: "0 0 740 561.759",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "screenrecorder-2_svg__linear-gradient",
    x1: 0.434,
    y1: 1,
    x2: 0.796,
    y2: -2.128,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3a3eef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12b9d9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "screenrecorder-2_svg__linear-gradient-2",
    y1: 1.609,
    x2: 0.806,
    y2: 0.157,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#11ebd2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#149529"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "screenrecorder-2_svg__Group_41145",
    "data-name": "Group 41145",
    transform: "translate(-182.8 -2371)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "screenrecorder-2_svg__Rectangle_13221",
    "data-name": "Rectangle 13221",
    width: 739.809,
    height: 561.759,
    rx: 46,
    transform: "translate(182.99 2371)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-2_svg__Path_21225",
    "data-name": "Path 21225",
    d: "M1074.316,220.7H428.193c-25.91.022-46.907,15.219-46.938,33.972V748.159c.032,18.751,21.031,33.943,46.938,33.96h646.123c25.907-.017,46.906-15.209,46.938-33.96V254.677C1121.223,235.924,1100.226,220.727,1074.316,220.7Zm43.555,527.454c-.033,17.4-19.517,31.494-43.555,31.511H428.193c-24.039-.017-43.522-14.113-43.555-31.511V254.677c.025-17.4,19.511-31.505,43.555-31.524h646.123c24.044.018,43.53,14.121,43.555,31.524ZM381.255,300.083V702.128h3.383V300.083Z",
    transform: "translate(-198.455 2150.295)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "screenrecorder-2_svg__Group_41141",
    "data-name": "Group 41141",
    transform: "translate(182.8 2371)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-2_svg__Path_21096",
    "data-name": "Path 21096",
    d: "M524.336,557.985H381.255v7.73H524.336a3.865,3.865,0,0,0,0-7.73Z",
    transform: "translate(-381.255 -94.626)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-2_svg__Path_21097",
    "data-name": "Path 21097",
    d: "M524.336,541.985H381.255v7.73H524.336a3.865,3.865,0,1,0,0-7.73Z",
    transform: "translate(-381.255 -105.69)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-2_svg__Path_21098",
    "data-name": "Path 21098",
    d: "M525.486,526.154a4.031,4.031,0,0,0-.558-.118,3.348,3.348,0,0,0-.592-.051H381.255v7.73H524.336a3.87,3.87,0,0,0,1.15-7.561Z",
    transform: "translate(-381.255 -116.753)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-2_svg__Path_21099",
    "data-name": "Path 21099",
    d: "M531.4,552.012l-12.6-55.92-4.11-18.217a5.811,5.811,0,0,0-6.952-4.381l-6.208,1.4-49.78,11.231a5.8,5.8,0,0,0-4.381,6.935c-2.672,24.882,2.6,47.835,14.056,69.316.846,1.607,1.742,3.214,2.672,4.821a5.735,5.735,0,0,0,1.641,2.909,5.822,5.822,0,0,0,5.294,1.471l6.529-1.471,4.026-.913,45.433-10.25a5.8,5.8,0,0,0,4.381-6.935Z",
    transform: "translate(-336.015 -153.149)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-2_svg__Path_21100",
    "data-name": "Path 21100",
    d: "M523.832,546.717l-12.009-53.2-2.876-12.771a5.438,5.438,0,0,0-6.5-4.11l-3.823.863-44.3,10a5.438,5.438,0,0,0-4.11,6.5c.389,19.367,2.419,36.942,10.758,47.666a24.221,24.221,0,0,0,16.61,17.811c.1.034.186.068.288.1.068.017.152.051.22.068a24.042,24.042,0,0,0,11.823.3l29.8-6.732a5.438,5.438,0,0,0,4.11-6.5Z",
    transform: "translate(-333.66 -150.966)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-2_svg__Path_21101",
    "data-name": "Path 21101",
    d: "M468.777,495.925a6.933,6.933,0,0,1,8.113-1.769,7.121,7.121,0,0,1,3.631,7.742c-.528,3.489-2.35,6.666-2.516,10.239a8.8,8.8,0,0,0,3.792,8.1c1.987,1.207,4.032-1.781,2.035-2.994-3.285-2-2.181-6.382-1.228-9.374,1.19-3.736,2.43-7.544.958-11.393A10.4,10.4,0,0,0,466.4,493.2C464.829,494.886,467.189,497.636,468.777,495.925Z",
    transform: "translate(-322.739 -141.655)",
    fill: "#3256eb"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "screenrecorder-2_svg__Ellipse_368",
    "data-name": "Ellipse 368",
    cx: 3.62,
    cy: 3.62,
    rx: 3.62,
    ry: 3.62,
    transform: "translate(158.363 381.77)",
    fill: "#3256eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-2_svg__Path_21102",
    "data-name": "Path 21102",
    d: "M827.21,432.361a27.48,27.48,0,0,0-41.632,16.255L735.157,579.992l-86.667-49.2a26.832,26.832,0,1,0-16.74,26.687c18.251,19.48,97.378,99.345,130.135,68.14,27.534-26.23,67.27-127.886,76.835-162.99a27.482,27.482,0,0,0-11.51-30.265Z",
    transform: "translate(-233.536 -184.571)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-2_svg__Path_21103",
    "data-name": "Path 21103",
    d: "M380.764,327.342l15.91,71.916,116.347,10.524,10.693-62.62Z",
    transform: "translate(118.233 119.207)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-2_svg__Path_21104",
    "data-name": "Path 21104",
    d: "M840.081,640.615H674.909l8.576-25.761,2.808-38.227,1.607.034,127.029,2.114,2.3.034,3.907,32.814a145.119,145.119,0,0,1,18.944,28.992Z",
    transform: "translate(-178.204 -81.736)",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-2_svg__Path_21105",
    "data-name": "Path 21105",
    d: "M751.372,411.154l57.912-2.983,26.9,42.5s25.954,5.325,22.445,64.962-36.921,115.108-36.921,115.108l2.482-8.51-4.311,12.318.553,6.917,5.881,7.325.605,7.576-5.211,11.986,7.086,11.477L679.814,665.4l-5.448-19.846,7.947-10.657L677.874,621l6.674-13.369,3.48-2.9s-38.07-57.2,5.633-100.274L711.2,474.633l19.626-23.944Z",
    transform: "translate(-179.758 -198.218)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-2_svg__Path_21106",
    "data-name": "Path 21106",
    d: "M629.159,464.584c-15.666-5.6-35.954-3.414-46.949,10.229-9.848,12.22-11.029,31.676,1.5,42.582,15.253,13.275,36.378,8.392,53.032.9,15.24-6.853,32.014-17.9,31.779-36.655a30.338,30.338,0,0,0-12.845-24.56,30.752,30.752,0,0,0-27.549-3.487c-4.022,1.47-2.285,7.955,1.783,6.468A23.572,23.572,0,0,1,661.57,478.4c2.353,15.569-10.95,25.653-23.312,31.8-13.562,6.74-30.824,13.188-45.343,5.445-12.42-6.623-14.691-21.729-7.805-33.331,8.537-14.383,27.755-16.442,42.266-11.257,4.073,1.455,5.826-5.024,1.783-6.468Z",
    transform: "translate(-247.586 -168.044)",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-2_svg__Path_21107",
    "data-name": "Path 21107",
    d: "M445.6,386.138c-11.252-4.02-25.824-2.452-33.721,7.347-7.073,8.777-7.921,22.751,1.078,30.584,10.955,9.535,26.128,6.027,38.09.648,10.946-4.922,22.994-12.859,22.825-26.328a21.79,21.79,0,0,0-9.226-17.64,22.087,22.087,0,0,0-19.787-2.5c-2.889,1.056-1.641,5.713,1.281,4.646a16.93,16.93,0,0,1,22.739,13.17c1.69,11.183-7.864,18.425-16.744,22.837-9.741,4.841-22.139,9.472-32.567,3.911-8.92-4.757-10.552-15.607-5.606-23.939,6.131-10.331,19.935-11.809,30.357-8.086,2.925,1.045,4.184-3.608,1.281-4.646Z",
    transform: "translate(-363.873 -219.798)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "screenrecorder-2_svg__Ellipse_369",
    "data-name": "Ellipse 369",
    cx: 30.421,
    cy: 20.614,
    rx: 30.421,
    ry: 20.614,
    transform: "translate(178.284 166.45) rotate(-15.216)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-2_svg__Path_21108",
    "data-name": "Path 21108",
    d: "M465.847,379.608l.06,37.878a2.539,2.539,0,0,0,5.074,0l-.06-37.878a2.539,2.539,0,0,0-5.074,0Z",
    transform: "translate(-322.762 -219.662)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-2_svg__Path_21109",
    "data-name": "Path 21109",
    d: "M456.386,392.726l36.919.09a2.539,2.539,0,0,0,0-5.074l-36.919-.09a2.539,2.539,0,0,0,0,5.074Z",
    transform: "translate(-330.999 -212.406)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-2_svg__Path_21110",
    "data-name": "Path 21110",
    d: "M383.234,402.647A2.184,2.184,0,0,1,381.255,405v-4.973a2.581,2.581,0,0,1,1.979,2.622Z",
    transform: "translate(-381.255 -203.85)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "screenrecorder-2_svg__Ellipse_370",
    "data-name": "Ellipse 370",
    cx: 3.383,
    cy: 3.383,
    rx: 3.383,
    ry: 3.383,
    transform: "translate(7.67 195.366)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-2_svg__Path_21111",
    "data-name": "Path 21111",
    d: "M459.216,583.545c-6.157,0-11.181,4.178-11.181,9.3s5.024,9.3,11.181,9.3h615.862V583.545Z",
    transform: "translate(-335.079 -76.953)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-2_svg__Path_21112",
    "data-name": "Path 21112",
    d: "M927.684,583.545v18.606H459.216c-6.157,0-11.181-4.178-11.181-9.3s5.024-9.3,11.181-9.3Z",
    transform: "translate(-335.079 -76.954)",
    fill: "url(#screenrecorder-2_svg__linear-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "screenrecorder-2_svg__Ellipse_371",
    "data-name": "Ellipse 371",
    cx: 18.606,
    cy: 18.606,
    rx: 18.606,
    ry: 18.606,
    transform: "translate(557.084 496.715)",
    fill: "#2f5ee9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-2_svg__Path_21113",
    "data-name": "Path 21113",
    d: "M484.1,426.395H381.255v7.747H484.1a3.873,3.873,0,1,0,0-7.747Z",
    transform: "translate(-381.255 -185.616)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-2_svg__Path_21114",
    "data-name": "Path 21114",
    d: "M596.494,395.614c3.355-8.622,15.776-11.462,22.647-5.473,4.1,3.575,7.16,8.483,12.582,10.238,5.852,1.893,11.4-1.233,16.4-3.94a24.893,24.893,0,0,1,8.383-3.245,20.679,20.679,0,0,1,8,.684c5.772,1.519,11.072,4.419,16.557,6.7a45.454,45.454,0,0,0,18.665,3.62c7.622-.116,15.246-.417,22.866-.631l25.6-.72a157.513,157.513,0,0,0,25.108-2.151c3.2-.61,1.847-5.5-1.349-4.893a144.449,144.449,0,0,1-22.954,1.947q-11.733.336-23.467.66c-7.957.224-15.914.465-23.872.671a45.855,45.855,0,0,1-10.6-.556,47.785,47.785,0,0,1-8.648-2.839c-5.664-2.377-11.152-5.393-17.157-6.853a24.446,24.446,0,0,0-17.055,1.847c-4.839,2.361-10.794,7.246-16.369,4.27-4.845-2.586-7.5-7.991-12.294-10.746-10.03-5.767-23.815-.545-27.942,10.061-1.185,3.045,3.72,4.364,4.893,1.349Z",
    transform: "translate(-235.935 -216.438)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-2_svg__Path_21115",
    "data-name": "Path 21115",
    d: "M604.08,421.651c3.6-5.33,7.652-11.457,14.22-13.269a10.171,10.171,0,0,1,8.565,1.1c2.33,1.567,4.107,3.853,6.336,5.559,4.7,3.6,9.9,3.04,14.958.551,4.275-2.1,9.092-6.259,14.161-4.594,3.541,1.163,6.3,4.006,9.729,5.455a11.122,11.122,0,0,0,10.175-.137,2.539,2.539,0,0,0-2.561-4.382c-2.926,1.712-6.341-.31-8.843-1.929a24.046,24.046,0,0,0-8.783-4.284c-5.662-.957-10.476,2.324-15.229,4.864a12.2,12.2,0,0,1-7.051,2.041c-2.767-.372-4.776-2.685-6.685-4.5a18.308,18.308,0,0,0-7.35-4.739,16.358,16.358,0,0,0-9.727.4c-7.448,2.551-12.074,9.047-16.3,15.3-1.832,2.714,2.562,5.256,4.382,2.561Z",
    transform: "translate(-230.512 -201.906)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-2_svg__Path_21116",
    "data-name": "Path 21116",
    d: "M570.129,385.824a4.594,4.594,0,0,1-6.47-5.605c1.477-3.738,6.847-2.874,8.881-.245,2.9,3.751,1.562,8.953-1.1,12.4-3.294,4.273-8.365,6.7-13.078,9.05a2.562,2.562,0,0,0,.606,4.637l18.634,4.045c3.184.691,4.544-4.2,1.349-4.893l-18.634-4.045.606,4.637c5.3-2.642,10.7-5.469,14.407-10.231a15.973,15.973,0,0,0,3.079-15.227,11.171,11.171,0,0,0-11.914-7.6,9.253,9.253,0,0,0-8,11.09c1.245,6.485,8.6,9.162,14.188,6.365,2.921-1.462.354-5.841-2.561-4.382Z",
    transform: "translate(-259.633 -222.763)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "screenrecorder-2_svg__Ellipse_372",
    "data-name": "Ellipse 372",
    cx: 3.383,
    cy: 3.383,
    rx: 3.383,
    ry: 3.383,
    transform: "translate(324.819 182.68)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-2_svg__Path_21117",
    "data-name": "Path 21117",
    d: "M671.375,426.565H559.485a3.865,3.865,0,0,0,0,7.73h111.89a3.865,3.865,0,1,0,0-7.73Z",
    transform: "translate(-260.688 -185.499)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-2_svg__Path_21118",
    "data-name": "Path 21118",
    d: "M632.857,475.192H495.115a1.692,1.692,0,0,1,0-3.383H632.857a1.692,1.692,0,0,1,0,3.383Z",
    transform: "translate(-303.694 -154.214)",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "screenrecorder-2_svg__Ellipse_373",
    "data-name": "Ellipse 373",
    cx: 16.915,
    cy: 16.915,
    rx: 16.915,
    ry: 16.915,
    transform: "translate(164.947 309.137)",
    fill: "#13a64c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-2_svg__Path_21119",
    "data-name": "Path 21119",
    d: "M455.087,353.921c-3.045,4.347-8,6.867-12.771,9.235q-23.494,11.671-47.006,23.325l.846,1.015.592.727.829.981q-6.47,8.677-12.94,17.338c-1.133,1.505-2.25,3.028-3.383,4.533V316.794c1.133-.457,2.25-.913,3.383-1.353q16.162-6.5,32.307-12.957c5.6-2.233,11.553-4.516,17.473-3.484,11.925,2.064,17.473,15.646,20.923,27.25C458.064,335.417,460.568,346.073,455.087,353.921Z",
    transform: "translate(-381.255 -273.883)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-2_svg__Path_21120",
    "data-name": "Path 21120",
    d: "M398.61,353.5q-6.977,9.362-13.971,18.741c-1.133,1.505-2.25,3.028-3.383,4.533v-4.313c1.133-1.505,2.267-3.028,3.383-4.533Q390.6,359.963,396.529,352a1.459,1.459,0,0,1,.22-.237C397.8,350.879,399.54,352.25,398.61,353.5Z",
    transform: "translate(-381.255 -237.417)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-2_svg__Path_21121",
    "data-name": "Path 21121",
    d: "M457.134,353.565c-2.6,4.736-7.239,7.662-11.908,10.081-5.328,2.757-10.758,5.362-16.137,8.035q-16.492,8.17-32.933,16.339c-.1.051-.22.1-.321.152-1.489.744-3.011-4.06-1.37-6.377,6.512-9.2,28.62-10,38.938-15.122,2.6-1.3,5.21-2.588,7.831-3.89a67.725,67.725,0,0,0,6.986-3.772,17.958,17.958,0,0,0,8.271-10.825,29.94,29.94,0,0,0-.288-12.906,98.8,98.8,0,0,0-3.806-13.5c-2.977-8.424-7.8-18.691-17.405-20.856-4.533-1.015-9.168.152-13.43,1.674-4.973,1.793-9.861,3.89-14.767,5.852q-11.087,4.44-22.158,8.88c-1.133.457-2.25.9-3.383,1.353V315.93c1.133-.457,2.25-.913,3.383-1.37q14.107-5.633,28.23-11.3a74.193,74.193,0,0,1,14.445-4.905,19.852,19.852,0,0,1,13.836,2.351,28.33,28.33,0,0,1,9.726,11.113,76.862,76.862,0,0,1,5.734,14.733C459.147,335.111,461.718,345.226,457.134,353.565Z",
    transform: "translate(-381.255 -274.406)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-2_svg__Path_21122",
    "data-name": "Path 21122",
    d: "M395.471,320.753h0c-.014.032-.025.064-.039.1a9.907,9.907,0,0,0-12.881,5.169h0a9.907,9.907,0,0,0,4.979,13v0l.122.053h0l18.03,7.9,7.953-18.152-.052-.023c.014-.03.029-.059.042-.089h0a9.909,9.909,0,0,0-5.1-13.052h0a9.909,9.909,0,0,0-13.052,5.1Z",
    transform: "translate(-380.936 -262.768)",
    fill: "url(#screenrecorder-2_svg__linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-2_svg__Path_21123",
    "data-name": "Path 21123",
    d: "M888.589,575.54c-1.083-2.3-2.2-4.635-3.383-6.986-4.246-8.576-9.066-17.541-14.192-26.539-14.09-24.865-30.446-50.068-43.318-68.2V473.8c-5.193-7.324-9.827-13.464-13.515-18a27.477,27.477,0,1,0-42.355,35.014l41.729,63.379,19.638,29.837,16,24.323L794.29,633.676l-8.982,4.144-26.472,12.212-.152.068c-.051-.034-.118-.068-.169-.1a27.18,27.18,0,0,0-4.093-2.047,26.778,26.778,0,0,0-11.012-1.844,26.473,26.473,0,0,0-8.136,1.641,26.831,26.831,0,0,0-17.1,20.348c-.118.541-.186,1.1-.254,1.675a1.265,1.265,0,0,0-.017.254h-.017A26.934,26.934,0,0,0,732.5,696.886c.338.169.677.338,1.032.49a25.429,25.429,0,0,0,5.278,1.742,26.7,26.7,0,0,0,6.918.592,27.167,27.167,0,0,0,6.377-1.049h.017a27.724,27.724,0,0,0,3.484-1.286,26.949,26.949,0,0,0,15.02-18.116c1.082-.135,2.3-.3,3.637-.49,2.74-.389,5.988-.88,9.658-1.472,1.455-.237,2.977-.49,4.55-.761,27.5-4.736,72.445-14.817,96.735-32.645,1.184-.88,2.317-1.759,3.383-2.656Z",
    transform: "translate(-148.59 -172.178)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-2_svg__Path_21124",
    "data-name": "Path 21124",
    d: "M1074.316,220.7H428.193c-25.91.022-46.907,15.219-46.938,33.972V748.159c.032,18.751,21.031,33.943,46.938,33.96h646.123c25.907-.017,46.906-15.209,46.938-33.96V254.677C1121.223,235.924,1100.226,220.727,1074.316,220.7Zm43.555,527.454c-.033,17.4-19.517,31.494-43.555,31.511H428.193c-24.039-.017-43.522-14.113-43.555-31.511V254.677c.025-17.4,19.511-31.505,43.555-31.524h646.123c24.044.018,43.53,14.121,43.555,31.524ZM381.255,300.083V702.128h3.383V300.083Z",
    transform: "translate(-381.255 -220.705)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "screenrecorder-2_svg__Ellipse_374",
    "data-name": "Ellipse 374",
    cx: 27.063,
    cy: 27.064,
    rx: 27.063,
    ry: 27.064,
    transform: "translate(34.421 486.566)",
    fill: "url(#screenrecorder-2_svg__linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-2_svg__Path_21125",
    "data-name": "Path 21125",
    d: "M415.9,607.955a1.8,1.8,0,0,1-.687-.139,1.738,1.738,0,0,1-1.089-1.631V581.273a1.765,1.765,0,0,1,3.013-1.248L429.6,592.482a1.767,1.767,0,0,1,0,2.5L417.14,607.434A1.738,1.738,0,0,1,415.9,607.955Z",
    transform: "translate(-358.526 -79.745)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "screenrecorder-2_svg__Ellipse_375",
    "data-name": "Ellipse 375",
    cx: 30.446,
    cy: 30.446,
    rx: 30.446,
    ry: 30.446,
    transform: "translate(582.622 50.247)",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-2_svg__Path_21126",
    "data-name": "Path 21126",
    d: "M749.7,380.814c-14.537-8.45-18.524-27.743-9.576-41.979a30.447,30.447,0,0,1,41.979-9.576c14.236,8.948,3.547,26.282,9.576,41.979C800.213,393.444,769.31,392.211,749.7,380.814Z",
    transform: "translate(-136.389 -256.014)",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-2_svg__Path_21127",
    "data-name": "Path 21127",
    d: "M717.271,352.257c-1.058,2.466-33.683,2.2-35.178,4.4C670.573,373.605,712.1,445.729,700.582,462.7l-1.6,1.913a75.826,75.826,0,0,0,10.795-6.09c.308-6.948.616-13.917.945-20.865a57.34,57.34,0,0,1,8.267,14.533c2.682-1.891,4.883-5.4,16.38-12.29A72.1,72.1,0,0,1,751.3,426.787Z",
    transform: "translate(-174.647 -236.88)",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "screenrecorder-2_svg__Ellipse_376",
    "data-name": "Ellipse 376",
    cx: 54,
    cy: 54,
    rx: 54,
    ry: 54,
    transform: "translate(504.796 87.361)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "screenrecorder-2_svg__Path_21128",
    "data-name": "Path 21128",
    d: "M783.51,475.727a26.006,26.006,0,0,1-8.707-14.291,55.875,55.875,0,0,0,.77,20.4c-2.924,2.2-5.76,4.287-8.443,6.178a57.346,57.346,0,0,0-8.267-14.533c-.33,6.948-.638,13.917-.945,20.865a75.829,75.829,0,0,1-10.8,6.09l1.6-1.913c11.521-16.973-18.292-48.215-6.772-65.167,3.232-4.749-11.367-42.279-22.492-43.972-9.894-1.495-9.476,1.363-19.062,3.452a47.975,47.975,0,0,0-4.6-11.894,39.3,39.3,0,0,1-.374,12.532c-3.408.132-6.089-2.039-9.718-2.594-23.151-3.54-20.8-28.582-14.357-36.519,6.464-7.915,27.922-10.289,37.816-12.862.9-.879,2.946-.33,3.848-1.165,18.961-17.353,44.319-20.226,67.14-12.535,24.336,8.2,39.51,24.076,47.3,48.548l2.234,19.584c2,6.3-.517,35.6-2.234,41.977C820.788,462.714,806.576,450.333,783.51,475.727Z",
    transform: "translate(-183.701 -256.575)",
    fill: "#272727"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenrecorder2);
export default __webpack_public_path__ + "static/media/screenrecorder-2.d21ceb74e4a6e4d795250d8b75262b81.svg";
export { ForwardRef as ReactComponent };